import React from 'react'
import { ScrollView, Text, View } from 'react-native'
import { useCssStyle } from '../../../customHook/getCssStyle';
import HeaderWithBack from '../../../components/Header/headerWithBack';
import { useSelector } from 'react-redux';
import { ImageComp } from '../../../components/Image/Image';
import { getCleanUrl } from '../../../utils/Helper';
import CustomPressable from '../../../components/customPressable/customPressable';
import { useTranslation } from 'react-i18next';
import RenderHTML from 'react-native-render-html';

const ReservationSuccess = (props) => {
    const { handleNext, handleGoBack } = props;

    const getStyles = useCssStyle();
    const { t } = useTranslation();
    const { currentWidget } = useSelector(state => state.deviceConfigSlice);


    const renderHeader = () => {
        return (
            <View style={getStyles(['widgetmainContainerHeaderContainer', 'sevenRoomsSuccessHeaderContainer'])} id='sevenRoomsSuccessHeaderContainer'>
                {
                    currentWidget?.widgetHeaderImageUrl && <ImageComp source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} style={getStyles(['widgetmainContainerHeaderImg', 'sevenRoomsSuccessHeaderImg'])} id={"sevenRoomsSuccessHeaderImg"}/>
                }
                <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'sevenRoomsSuccessMainPageHeaderTitleContainer'])} id='sevenRoomsSuccessMainPageHeaderTitleContainer'>
                    <Text style={getStyles(['widgetmainContainerHeaderTitle', 'sevenRoomsSuccessHeaderTitle'])} id='sevenRoomsSuccessHeaderTitle'>{t('reservations.success.success_heading')}</Text>
                    <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'sevenRoomsSuccessHeaderSubTitle'])} id='sevenRoomsSuccessHeaderSubTitle'>{t('reservations.success.success_sub_heading')}</Text>
                </View>
            </View>
        )
    }

    return (
        <View style={getStyles(['widgetRootContainer', 'sevenRoomsSuccessRootContainer'])} id="widgetRootContainer sevenRoomsSuccessRootContainer">
            <HeaderWithBack handleCustomBackPress={handleGoBack} />

            <ScrollView
                automaticallyAdjustKeyboardInsets={true} 
                contentContainerStyle={getStyles(['widgetmainContainer', 'sevenRoomsSuccessMainContainer'])} 
                showsVerticalScrollIndicator={false}
                id='sevenRoomsSuccessMainContainer'
            >
                {renderHeader()}
                                
                <View style={getStyles(['widgetmainContainerChildContainer', 'sevenRoomsSuccessMainContainerChildContainer'])} id='sevenRoomsSuccessMainContainerChildContainer'>
                    <Text style={getStyles(["reservationsSuccessMessage"])} id='reservationsSuccessMessage'>{t('reservations.success_message')}</Text>
                </View>

            </ScrollView>

            <View style={getStyles(['sevenRoomsReservationDetails_button_container'])} id='sevenRoomsReservationDetails_button_container'>
                <CustomPressable style={getStyles(['primaryBtn'])} onPress={handleNext} id='primaryBtn'>
                    <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>{t('reservations.next')}</Text>
                </CustomPressable>
            </View>


        </View>
  )
}

export default ReservationSuccess
